<template>
  <header class="header" :class="{ 'scrolled': isScrolled }">
    <div class="header-container">
      <!-- 品牌标识 -->
      <router-link to="/" class="brand">
        <img
          src="/3.jpg"
          alt="Logo"
          class="logo"
        >
        <div class="brand-text">
          <span class="company-name">Chuan Yan</span>
<!--          <span class="company-tagline">Worldwide Business Solutions</span>-->
        </div>
      </router-link>

      <!-- 桌面导航 -->
      <nav class="desktop-nav">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="nav-link"

        >
          <span class="nav-text">{{ item.name }}</span>
          <div class="nav-indicator"></div>
        </router-link>
      </nav>

      <!-- 移动菜单按钮 -->
      <div
        class="hamburger"
        :class="{ 'active': isMobileMenuOpen }"
        @click="toggleMobileMenu"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </div>

    <!-- 移动菜单 -->
    <transition name="nav-fade">
      <div
        v-show="isMobileMenuOpen"
        class="mobile-menu"
        @click="closeMobileMenu"
      >
        <div class="mobile-menu-content">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="mobile-nav-link"
          >
            {{ item.name }}
            <div class="mobile-indicator"></div>
          </router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: "OptimizedHeader",
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      navItems: [
        { path: "/", name: "Home" },
        { path: "/products", name: "Products" },
        { path: "/news", name: "News" },
        { path: "/about", name: "About" },
        { path: "/contact", name: "Contact" }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(10, 26, 47, 0.96);
  backdrop-filter: blur(12px);
  height: 60px;
  transition: all 0.4s cubic-bezier(0.33, 1, 0.68, 1);
  text-align: center;
  &.scrolled {
    box-shadow: 0 4px 20px rgba(10, 26, 47, 0.2);
  }
}


.header-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 1.5rem; // 调整内边距
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.75rem; // 缩小间距

  .logo {
    height: 30px; // 缩小Logo尺寸
      border-radius: 50%;
  }

  .company-name {
    font-size: 1.25rem; // 调整字号
    color: #C5A47E;
    font-weight: 500;
    letter-spacing: 0.05em;
  }

  .company-tagline {
    font-size: 0.8rem; // 调整字号
    color: rgba(197,164,126,0.8);
    letter-spacing: 0.1em;
  }
}

// 修复问题2：桌面导航显示优化
.desktop-nav {
  display: flex;
  gap: 1.5rem;
  margin-left: auto; // 确保右侧对齐

  .nav-link {
    position: relative;
    color: rgba(197,164,126,0.9);
    padding: 0.25rem 0;
    font-size: 0.95rem; // 调整字号

    .nav-indicator {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: #C5A47E;
      transition: width 0.4s cubic-bezier(0.65, 0, 0.35, 1);
    }

    &:hover,
    &.active {
      color: #fff;

      .nav-indicator {
        width: 100%;
      }
    }
  }
}

.hamburger {
  display: none;
  width: 28px;
  height: 20px;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  z-index: 1001;

  .bar {
    height: 2px;
    background: #C5A47E;
    transition: all 0.4s cubic-bezier(0.33, 1, 0.68, 1);
  }

  &.active {
    .bar:nth-child(1) {
      transform: translateY(8px) rotate(45deg);
    }
    .bar:nth-child(2) {
      opacity: 0;
    }
    .bar:nth-child(3) {
      transform: translateY(-8px) rotate(-45deg);
    }
  }
}

// 修复问题3：移动菜单背景优化
.mobile-menu {
  position: fixed;
  top: 60px; // 与header高度一致
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 26, 47, 0.98);
  backdrop-filter: blur(24px); // 增强模糊
  padding: 1rem 0;

  &-content {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0;
  }
}

.mobile-nav-link {
  display: block;
  padding: 1rem 0;
  color: #C5A47E;
  font-size: 1.1rem;
  position: relative;
  border-bottom: 1px solid rgba(197,164,126,0.2);
    background: #0A1A2F;

  .mobile-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 1px;
    background: #C5A47E;
    transition: width 0.3s ease;
  }

  &:hover .mobile-indicator {
    width: 100%;
  }
}

.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: all 0.4s ease;
}

.nav-fade-enter-from,
.nav-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 1rem;
  }

  .desktop-nav {
    display: none;
  }

  .hamburger {
    display: flex;
  }

  .brand {
    .company-tagline {
      display: none;
    }
  }

  .mobile-menu {
    top: 60px; // 保持与header高度一致
  }

}
</style>
